var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaucet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_3055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.8691H14.6902C13.9538 12.2391 13.028 11.7877 12 11.5566V9.32725L10.5 9.16881L9 9.32725V11.5566C7.97203 11.791 7.04625 12.241 6.30984 12.8691H0.75C0.551088 12.8691 0.360322 12.9481 0.21967 13.0888C0.0790176 13.2294 0 13.4202 0 13.6191L0 18.1191C0 18.318 0.0790176 18.5088 0.21967 18.6495C0.360322 18.7901 0.551088 18.8691 0.75 18.8691H5.09953C6.06469 20.6377 8.10938 21.8691 10.5 21.8691C12.8906 21.8691 14.9353 20.6377 15.9005 18.8691H16.5C16.8978 18.8691 17.2794 19.0272 17.5607 19.3085C17.842 19.5898 18 19.9713 18 20.3691C18 20.767 18.158 21.1485 18.4393 21.4298C18.7206 21.7111 19.1022 21.8691 19.5 21.8691H22.5C22.8978 21.8691 23.2794 21.7111 23.5607 21.4298C23.842 21.1485 24 20.767 24 20.3691C24 18.38 23.2098 16.4723 21.8033 15.0658C20.3968 13.6593 18.4891 12.8691 16.5 12.8691ZM3.82453 8.36491L10.5 7.66178L17.1755 8.36491C17.617 8.41178 18 8.04569 18 7.57741V6.16084C18 5.69209 17.617 5.32647 17.1755 5.37288L12 5.91944V4.61913C12 4.42021 11.921 4.22945 11.7803 4.0888C11.6397 3.94814 11.4489 3.86913 11.25 3.86913H9.75C9.55109 3.86913 9.36032 3.94814 9.21967 4.0888C9.07902 4.22945 9 4.42021 9 4.61913V5.91944L3.82453 5.37288C3.38297 5.32647 3 5.69256 3 6.16084V7.57741C3 8.04569 3.38297 8.41178 3.82453 8.36491V8.36491Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_3055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.869125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaucet);
export default __webpack_public_path__ + "static/media/faucet.bbdd2c339fe7535fb1b77dd00930b5ca.svg";
export { ForwardRef as ReactComponent };